export default __webpack_public_path__ + "static/custom-marker-shapes-56b2786d1294159f3bab0e767929e65a.png";